import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchStyleguide({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="m16.91 11.63.577-1 1.752 3.035a1 1 0 0 1-.366 1.366l-5.56 3.21a3.98 3.98 0 0 0 .604-1.428l.066-.113 4.39-2.535-1.463-2.535zm-6.718 8.365.021.036.071-.04-.092.005zM14 14.67V16c0 .279-.028.55-.083.813l4.011-6.947a1 1 0 0 0-.366-1.366L14.964 7 14 6.443v1.155l3.062 1.768L14 14.67z"/>
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M7 6h6v10h1V6a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10h1V6zm6 10a3 3 0 1 1-6 0H6a4 4 0 0 0 8 0h-1z"/>
            <circle cx="10" cy="16" r="1.5" stroke={fill}/>
        </svg>
    );
}

export default IconSearchStyleguide;
